import { useRequest } from '@10000/react'
import { Body, Box, Dialog, H4 } from '../'
import { Avatar, Form, Submit, Text } from '../../forms'
import { randomInt } from '@10000/common'
import { userRoles } from '../../../lookups'

export const AdminDialog = ({ onClose, ...props }) => {
  const request = useRequest('tenant')
  const sendInvite = (values) => request('userAdded', { ...values, admin: true }).then(onClose)

  return (
    <Dialog onClose={onClose} showControls={false} {...props} mobileBackground="white">
      <Form onSubmit={sendInvite} values={{ avatar: randomInt(6) }} style={{ width: '100%' }}>
        <Box column gap={32} fullWidth>
          <H4 color="black">Invite new admin</H4>
          <Box column fullWidth gap={8}>
            <Avatar
              name="avatar"
              size="large"
              label="ADMIN"
              labelColor="white"
              labelBackground="red"
            />
            <Body color="black" align="center" mt={8}>{userRoles.admin.description}</Body>
            <Text dark title="Name" name="name" required/>
            <Text dark title="Email" name="email" type="email" required/>
          </Box>
          <Submit fullWidth>Invite</Submit>
        </Box>
      </Form>
    </Dialog>
  )
}